// extracted by mini-css-extract-plugin
export default {"PasswordResetEmailForm__submit":"yq_a bhi_qj bhi_to"};